import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSchool, faHandshake, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import schoolImageBangalore from './../../assets/rimc-2024.jpg';
import schoolDholpur from './../../assets/schoolDholpur.png';
import schoolAjmer from './../../assets/schoolAjmer.png';
import schoolChail from './../../assets/schoolChail.png';
import SainikSchoolGothra from './../../assets/SainikSchoolGothra.png';
import Kunjpuraschl from './../../assets/Kunjpuraschl.png';
import khera from './../../assets/khera.jpg';
import asthal from './../../assets/Asthal.jpg';
import majra from './../../assets/SKDLJPS.jpg';

const schools = [
    // { name: 'RMS Bangalore', image: schoolImageBangalore, link: '/rmsBangalore' },
    // { name: 'RMS Dholpur', image: schoolDholpur, link: '/rmsDholpur' },
    // { name: 'RMS Ajmer', image: schoolAjmer, link: '/rmsAjmer' },
    // { name: 'RMS Chail', image: schoolChail, link: '/rmsChail' },
    { name: 'Sainik School, Gothra Tappa Khori, Rewari', image: SainikSchoolGothra, link: '/rmsGothra' },
    { name: 'Sainik School, Kunjpura, Karnal', image: Kunjpuraschl, link: '/rmsKunjpura' },
];
const schoolspp = [
    { name: 'Shri Baba Mastnath Senior Secondary (Res) Public School Asthal Bohar, (Rohtak)', image: asthal, link: '/rmsAsthal' },
    { name: 'Smt Kesari Devi Lohia Jairam Public School Lohar Majra Kurukshetra', image: majra, link: '/rmsMajra' },
    { name: 'Sainik School, Khara Kheri', image: khera, link: '/rmsKhera' }
   
];

const SainikSchool = () => {
    return (
        <>
            <div style={{
                backgroundImage: `url(${footerBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '30px 0',
                color: 'white',
                margin: '2%',
                borderRadius: '10px'
            }}>
                <Container>
                    <h3 className="fw-bold mb-0 text-center">
                        <FontAwesomeIcon icon={faSchool} className="me-2" />
                        Sainik Schools
                    </h3>
                </Container>
            </div>

            <Container className="py-5">
                <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faSchool} className="me-2" />
                            Sainik Schools
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="row justify-content-center">
                            {schools.map((school, index) => (
                                <div key={index} className="col-md-6 col-lg-4 mb-4">
                                    <Link to={school.link} style={{ textDecoration: 'none' }}>
                                        <div 
                                            className="h-100"
                                            style={{
                                                borderRadius: '15px',
                                                overflow: 'hidden',
                                                background: 'white',
                                                boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
                                                transition: 'all 0.3s ease',
                                                cursor: 'pointer'
                                            }}
                                            onMouseOver={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-8px)';
                                                e.currentTarget.style.boxShadow = '0 15px 35px rgba(30,60,114,0.25)';
                                            }}
                                            onMouseOut={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
                                            }}
                                        >
                                            <div style={{ position: 'relative', overflow: 'hidden' }}>
                                                <img 
                                                    src={school.image} 
                                                    alt={school.name} 
                                                    style={{
                                                        width: '100%',
                                                        height: '200px',
                                                        objectFit: 'cover',
                                                        transition: 'transform 0.3s ease'
                                                    }}
                                                    onMouseOver={(e) => {
                                                        e.currentTarget.style.transform = 'scale(1.1)';
                                                    }}
                                                    onMouseOut={(e) => {
                                                        e.currentTarget.style.transform = 'scale(1)';
                                                    }}
                                                />
                                            </div>
                                            <div className="p-3 text-center">
                                                <h5 style={{ color: '#1e3c72', fontWeight: '600', margin: '0' }}>
                                                    {school.name}
                                                </h5>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </CardBody>
                </Card>

                <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faHandshake} className="me-2" />
                            Sainik Schools on PPP (Public-Private Partnership) Model
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="row">
                            {schoolspp.map((school, index) => (
                                <div key={index} className="col-md-6 col-lg-4 mb-4">
                                    <Link to={school.link} style={{ textDecoration: 'none' }}>
                                        <div 
                                            className="h-100"
                                            style={{
                                                borderRadius: '15px',
                                                overflow: 'hidden',
                                                background: 'white',
                                                boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
                                                transition: 'all 0.3s ease',
                                                cursor: 'pointer'
                                            }}
                                            onMouseOver={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-8px)';
                                                e.currentTarget.style.boxShadow = '0 15px 35px rgba(22,160,133,0.25)';
                                            }}
                                            onMouseOut={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
                                            }}
                                        >
                                            <div style={{ position: 'relative', overflow: 'hidden' }}>
                                                <img 
                                                    src={school.image} 
                                                    alt={school.name} 
                                                    style={{
                                                        width: '100%',
                                                        height: '200px',
                                                        objectFit: 'cover',
                                                        transition: 'transform 0.3s ease'
                                                    }}
                                                    onMouseOver={(e) => {
                                                        e.currentTarget.style.transform = 'scale(1.1)';
                                                    }}
                                                    onMouseOut={(e) => {
                                                        e.currentTarget.style.transform = 'scale(1)';
                                                    }}
                                                />
                                            </div>
                                            <div className="p-3 text-center">
                                                <h5 style={{ color: '#16a085', fontWeight: '600', margin: '0' }}>
                                                    {school.name}
                                                </h5>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </CardBody>
                </Card>

                <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faGraduationCap} className="me-2" />
                            Rashtriya Indian Military College
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="row justify-content-center">
                            <div className="col-md-6 col-lg-4">
                                <Link to="/rimc" style={{ textDecoration: 'none' }}>
                                    <div 
                                        style={{
                                            borderRadius: '15px',
                                            overflow: 'hidden',
                                            background: 'white',
                                            boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer'
                                        }}
                                        onMouseOver={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-8px)';
                                            e.currentTarget.style.boxShadow = '0 15px 35px rgba(142,68,173,0.25)';
                                        }}
                                        onMouseOut={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
                                        }}
                                    >
                                        <div style={{ position: 'relative', overflow: 'hidden' }}>
                                            <img 
                                                src={schoolImageBangalore} 
                                                alt="RIMC" 
                                                style={{
                                                    width: '100%',
                                                    height: '200px',
                                                    objectFit: 'cover',
                                                    transition: 'transform 0.3s ease'
                                                }}
                                                onMouseOver={(e) => {
                                                    e.currentTarget.style.transform = 'scale(1.1)';
                                                }}
                                                onMouseOut={(e) => {
                                                    e.currentTarget.style.transform = 'scale(1)';
                                                }}
                                            />
                                        </div>
                                        <div className="p-3 text-center">
                                            <h5 style={{ color: '#8e44ad', fontWeight: '600', margin: '0' }}>
                                                RIMC, Dehradun
                                            </h5>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Container>
        </>
    );
};

export default SainikSchool;
